import React, { Fragment } from 'react';

import { ReportSetting } from '../../../../../interfaces/ReportSetting';
import { REPORT_SELECTORS_TYPES } from '../../../../../constants/REPORT_SELECTORS_TYPES';
import { Selector } from '../Selector/Selector';
import { ParentSelectorSettings } from '../Selector/hooks/useSelector';

type SelectorsGroupProps = {
  selectors: ReportSetting[];
  parentSelectorSettings?: ParentSelectorSettings;
  reportType: string;
};

const SelectorsGroup = ({
  selectors,
  parentSelectorSettings,
  reportType,
}: SelectorsGroupProps) => {
  return (
    <>
      {selectors.map(
        ({ subSettings, selectorFunctionalType, description, ...selectorSettings }) => {
          if (selectorSettings.selectorType === REPORT_SELECTORS_TYPES.NO_SELECTOR) {
            return null;
          }

          return (
            <Fragment key={selectorSettings.selectorType}>
              <Selector
                selectorSettings={selectorSettings}
                parentSelectorSettings={parentSelectorSettings}
                reportType={reportType}
              />
              {subSettings.length > 0 && (
                <SelectorsGroup
                  selectors={subSettings}
                  parentSelectorSettings={selectorSettings}
                  reportType={reportType}
                />
              )}
            </Fragment>
          );
        },
      )}
    </>
  );
};

export { SelectorsGroup };
